import type { PageModalProps } from "./page-modal.type";
import type { ModalProps } from "antd";

import { Flex, Typography } from "antd";
import cn from "classnames";
import { useLocation, useNavigate } from "react-router";

import { ModalFullscreen } from "@/ui/modal-fullscreen";

import { usePageModalLocationState } from "./page-modal.hook";

import "./page-modal.style.less";

const { Title } = Typography;

const PageModal = ({
  loading,
  title,
  beforeTitle,
  afterTitle,
  breadcrumb,
  headerActions,
  className,
  classNames,
  children,
  ...modalProps
}: PageModalProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { backgroundLocation } = usePageModalLocationState();

  const showTitle = !loading ? true : false;
  const showHeader = breadcrumb || headerActions?.length ? true : false;

  const closeModalAndRedirect = () => {
    if (backgroundLocation?.pathname) {
      navigate(
        `${backgroundLocation.pathname}${backgroundLocation.search ?? ""}`
      );
    } else if (location.state?.from) {
      navigate(location.state.from);
    } else {
      navigate(-1);
    }
  };

  const onCancel: ModalProps["onCancel"] = (e) => {
    e.stopPropagation();
    closeModalAndRedirect();
  };

  return (
    <ModalFullscreen
      title={
        showTitle && (
          <Flex align="center" gap="small">
            {beforeTitle}
            <Title level={2} className="page-modal-title">
              {title}
            </Title>
            {afterTitle}
          </Flex>
        )
      }
      footer={null}
      keyboard={false} // disable close on ESC click
      mask={{ closable: false }} // disable close on mask click
      destroyOnHidden
      {...modalProps}
      open
      onCancel={onCancel}
      loading={loading}
      className={cn("page-modal", className)}
      classNames={{
        ...classNames,
        header: cn("page-modal--header", classNames?.header),
      }}
    >
      {showHeader && (
        <div className="page-modal-header">
          <div className="breadcrumb">{breadcrumb}</div>
          <div className="actions">
            {headerActions?.map((action) => action)}
          </div>
        </div>
      )}
      <div className="page-modal-content">{children}</div>
    </ModalFullscreen>
  );
};

export default PageModal;
